<script lang="ts">
  import type { Asset } from '@storyblok-types';
  import { setContainerContextWidth } from '@athena-lib/container-context.svelte';
  import clsx from 'clsx';
  import { getFocalPointClasses } from '../shared/image-utils';
  import ImageOrVideo from '../ImageOrVideo.svelte';

  const {
    image,
    class: className,
    fit,
    loading = 'lazy',
    loopVideo,
  }: {
    image: Asset | undefined;
    class?: string;
    fit: 'cover' | 'contain';
    loading?: 'lazy' | 'eager';
    loopVideo?: boolean;
  } = $props();
  setContainerContextWidth({ sm: 1, md: 0.5, lg: 0.5 });
</script>

{#if image}
  <ImageOrVideo
    {loopVideo}
    autoplay={true}
    asset={image}
    {loading}
    innerImageClass={clsx(
      className,
      getFocalPointClasses(image),
      fit == 'cover' ? 'object-cover' : 'object-contain',
    )}
    videoClass={clsx(className, 'object-cover h-full w-full')}
  />
{/if}
